var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:['button', { first: _vm.first }],attrs:{"to":_vm.route}},[_vm._v(" "+_vm._s(_vm.buttonName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }